import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type ProductKeys, is3pProductKey } from '../../constants/product-keys';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type ProductOptionClickedArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	isConnected: boolean;
	productKey: ProductKeys | undefined;
	datasourceId?: string;
	index?: number;
	isInShowMore?: boolean;
};

export const onAppFilterOptionClicked = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	isConnected,
	productKey,
	datasourceId,
	index,
	isInShowMore,
}: ProductOptionClickedArgs): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'button',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			productKey: productKey ?? 'all',
			...(datasourceId && { datasourceId }),
			is3pProduct: productKey ? is3pProductKey(productKey) : false,
			isConnected,
			...(index !== undefined && { index }),
			...(isInShowMore !== undefined && { isInShowMore }),
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
